import { Button, Divider, Stack } from '@mui/material';
import { useForm } from 'react-typed-form';
import { FieldTextRequired, FieldText } from '../../form';
import { useNavigate } from 'react-router';
import { Api, useApiCallable } from '../../api';
import ConfirmModal from '../../components/ConfirmModal';
import { useState } from 'react';

type Props = {
  existing: Api.ClientClassification.V | null;
};

export default function UserClassificationForm({ existing }: Props) {
  const navigate = useNavigate();
  const callApi = useApiCallable();

  const [showModal, setShowModal] = useState(false);

  const form = useForm<{
    name: string;
    description: string | null;
  }>({
    defaultValues: {
      name: existing?.name ?? '',
      description: existing?.description ?? '',
    },
    onSubmit: async (values, f) => {
      const { setLoading, addSubmitError } = f;
      setLoading(true);
      const response = await callApi(
        existing
          ? `/client-classifications/${existing.id}`
          : `/client-classifications`,
        {
          method: existing ? 'PATCH' : 'POST',
          jsonBody: values,
        },
        { addSubmitError },
      );
      setLoading(false);
      if (!response) return;
      navigate(-1);
    },
  });

  return (
    <Stack gap={3}>
      <FieldTextRequired field={form.getField('name')} label="Name" required />
      <FieldText field={form.getField('description')} label="Description" />

      <Divider />

      <Stack direction="row" gap={2} justifyContent="space-between">
        <Stack gap={2} direction="row">
          <Button variant="contained" onClick={form.handleSubmit}>
            {existing ? 'Save Changes' : 'Create'}
          </Button>
        </Stack>
        {existing && (
          <Button
            variant="contained"
            color="error"
            onClick={() => setShowModal(true)}
          >
            Delete
          </Button>
        )}
      </Stack>

      {existing && showModal && (
        <ConfirmModal
          title="Delete User Classification"
          onClose={() => setShowModal(false)}
          onConfirm={async () => {
            const response = await callApi(
              `/client-classifications/${existing.id}`,
              { method: 'DELETE' },
            );
            if (!response) return;
            setShowModal(false);
            navigate(-1);
          }}
          color="error"
        >
          Are you sure you want to delete '{existing.name}'? This action cannot
          be undone.
        </ConfirmModal>
      )}
    </Stack>
  );
}
